import { render, staticRenderFns } from "./Break.vue?vue&type=template&id=5a4bb5c9&"
import script from "./Break.vue?vue&type=script&lang=ts&"
export * from "./Break.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports